module.exports = __webpack_public_path__ + "img/cbs_logo.7e6967a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/cbs_logo.svg
// module id = ./assets/img/media/cbs_logo.svg
// module chunks = 0 9 11 12